module.exports = __webpack_public_path__ + "media/images/vector-16@2x-bec598b99b1dc1294815ac49b9f8de2f.png";